<template>
    <div>
        <div class="modal-small-toolbar">
            <span>Lease Information</span>
        </div>
        <form>
            <div class="flex p-4 mr-2">
                <div class="flex flex-1 flex-col bg-gray-100 shadow-md rounded mr-6 p-6 border border-gray-300">
                    <div class="flex mb-4">
                        <div class="mr-4">
                            <label for="name">Name</label>
                            <input type="text" name="name" class="mt-1 form-input w-full" v-model="leases.selectedLease.name">
                            <div v-if="errors.name" class="form-error">{{ errors.name[0] }}</div>
                        </div>
                        <div class="mr-4">
                            <label for="start_date" class="">Start Date</label>
                            <date-picker
                                v-model="leases.selectedLease.start_date"
                                lang="en"
                                :first-day-of-week="7"
                                format="MM/DD/YYYY"
                                :value-type="valueType"
                                input-name="start_date"
                                input-class="mt-0 form-input"
                                :input-attr="{ size: 11, required: true }">
                            </date-picker>
                            <div v-if="errors.start_date" class="form-error">{{ errors.start_date[0] }}</div>
                        </div>
                        <div>
                            <label for="end_date">End Date</label>
                            <date-picker
                                v-model="leases.selectedLease.end_date"
                                lang="en"
                                :first-day-of-week="7"
                                format="MM/DD/YYYY"
                                :value-type="valueType"
                                input-name="end_date"
                                input-class="mt-0 form-input"
                                :input-attr="{ size: 11, required: true }">
                            </date-picker>
                            <div v-if="errors.end_date" class="form-error">{{ errors.end_date[0] }}</div>
                        </div>
                    </div>
                    <div>
                        <textarea v-model="leases.selectedLease.notes" class="mt-1 w-full form-textarea text-sm" cols="10" rows="5" name="notes" placeholder="Lease Notes"></textarea>
                    </div>

                    <button 
                        type="button"
                        @click="confirmDeleteLease"
                        class="mt-5 btn btn-small btn-red min-w-fit">
                            Delete Lease
                    </button>
                </div>

                <div>
                    <div class="border-b border-dotted border-gray mb-4 pb-3">
                        <div class="flex justify-between items-center">
                            <label class="mr-10" for="free_months"># Free Months</label>
                            <input v-model="leases.selectedLease.free_months" type="text" name="free_months" class="mt-1 form-input" size="2" required>
                        </div>
                        <div v-if="errors.free_months" class="form-error">{{ errors.free_months[0] }}</div>
                    </div>
                
                    <div class="flex justify-between items-center border-b border-dotted border-gray mb-4 pb-3">
                        <label class="mr-10">Free Months Included</label>
                        <toggle-switch v-model="leases.selectedLease.free_months_included" name="free_months_included"></toggle-switch>
                    </div>

                    <div class="flex justify-between items-center">
                        <label class="mr-10">Will Not Renew</label>
                        <toggle-switch v-model="leases.selectedLease.will_not_renew" name="will_not_renew"></toggle-switch>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapState } from 'vuex';
    import DatePicker from 'vue2-datepicker';

    export default {
        components: {
            DatePicker
        },

        props: {
        	formErrors: {
        		type: [String, Object],
        		required: false
        	}
        },

        data() {
            return {
                valueType: {
                    value2date: (value) => {
                        return value ? moment(value, 'YYYY-MM-DD').toDate() : null
                    },
                    date2value: (date) => {
                        return date ? moment(date).format('YYYY-MM-DD') : null
                    }
                }                 
            }
        },

        computed: {
            ...mapState(['leases']),
            ...mapState(['sites']),

            selectedLeaseId: {
                get() {
                    return this.leases.selectedLease ? this.leases.selectedLease.id : '';
                },

                set(leaseId) {
                    this.leases.selectedLease = _.find(this.sites.selectedSite.leases, ['id', leaseId])
                }
            },

            errors() {
            	return this.formErrors;
            }
        },

        methods: {
            confirmDeleteLease() {
                if (this.selectedLeaseId == "new") {
                    this.removeLease();
                    
                    return;
                }

                this.$swal({
                    title: 'Are you sure?',
                    text: "Are you sure you want to delete this Lease?",
                    type: 'warning',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Delete it',
                    confirmButtonClass: 'btn btn-red',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        this.deleteLease();
                    }
                });
            },

            deleteLease() {
                axios.delete('/leases/' + this.selectedLeaseId)
                    .then((response) => {
                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        });

                        this.removeLease();
                    })
                    .catch((error) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: error.response.data.message
                        });
                    }
                );
            },

            removeLease() {
                _.remove(this.sites.selectedSite.leases, (lease) => {
                    return lease.id == this.selectedLeaseId
                });

                this.selectedLeaseId = this.sites.selectedSite.leases[0] ? this.sites.selectedSite.leases[0].id : '';

                this.section = 'lease-info';
            },
        }
    }
</script>